import r from"../utils.js";function t(t){return r.isObject(t)&&!0===t.isAxiosError}export{t as default};
